
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationReturnTaxGrid extends Serenity.EntityGrid<CertificationReturnTaxRow, any> {
        protected getColumnsKey() { return 'CertificationReturn.CertificationReturnTax'; }
        protected getDialogType() { return CertificationReturnTaxDialog; }
        protected getIdProperty() { return CertificationReturnTaxRow.idProperty; }
        protected getInsertPermission() { return CertificationReturnTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return CertificationReturnTaxRow.localTextPrefix; }
        protected getService() { return CertificationReturnTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}